export default __webpack_public_path__ + "static/media/distancing.93576289.jpg";